import { type FC } from 'react'

import { NfcLandingPageHero } from './NfcLandingPageHero'
import { NfcLandingPageHeroActions } from './NfcLandingPageHeroActions'

export const NfcLandingPageHeroHeader: FC = () => {
  return (
    <div className="tablet:bg-light-brand-medium">
      <div className="container px-0 tablet:flex tablet:items-center tablet:gap-14 tablet:px-3.5 tablet:py-12">
        <NfcLandingPageHeroActions />
        <NfcLandingPageHero />
      </div>
    </div>
  )
}
